import {VStack} from 'platform/foundation';

import {SalesLeagueKpiPanelSkeleton} from './SalesLeagueKpiPanelSkeleton';
import {SalesLeaguePodiumSkeleton} from './SalesLeaguePodiumSkeleton';
import {SalesLeagueTableSkeleton} from './SalesLeagueTableSkeleton';

const BOARD_SPACING = 6;

/**
 * Everything below the header while the board loads. The header itself stays real — the
 * period switcher is the one control that has to work before the data arrives, exactly as
 * it does on an empty board.
 */
export function SalesLeagueBoardSkeleton() {
  return (
    <VStack spacing={BOARD_SPACING}>
      <SalesLeaguePodiumSkeleton />
      <SalesLeagueKpiPanelSkeleton />
      <SalesLeagueTableSkeleton />
    </VStack>
  );
}
